import React from "react";
import { InputAdornment, ListSubheader, TextField, MenuItem, Select, Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { makeStyles } from "@mui/styles";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import ListItemText from "@mui/material/ListItemText";
import OutlinedInput from "@mui/material/OutlinedInput";
import Checkbox from "@mui/material/Checkbox";
import checked from "../Assets/Images/Common/checked.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import { useState, useEffect } from "react";

const useStyles = makeStyles((theme) => ({
	label: {
		fontFamily: "Inter-Regular !important",
		fontSize: "1.6rem !important",
		lineHeight: "2.4rem !important",
		color: "#98A2B3 !important",
		background: "#F2F4F7 !important",
		fontWeight: "400 !important",
		padding: "0px !important",
		"&.Mui-focused": {
			display: "none !important",
			color: " #84CAFF !important",
		},
		//  top: "50% !important",
		//  transform: "translate(10%, -50%) scale(1) !important"
		transform: "translate(14px, 10px) scale(1) !important",
	},
	helperText: {
		fontSize: "1.4rem !important",
		margin: "0.2rem 0 0 0 !important",
		color: "#d32f2f !important",
		textAlign: "left !important",
		fontFamily: "Inter-Medium !important",
	},
	form: {
		margin: "0rem !important",
	},
	select: {
		minWidth: "15rem",
		fontFamily: "Inter-Regular !important",
		fontSize: "1.6rem !important",
		border: "1px solid #EFF8FF !important",
		lineHeight: "2.4rem !important",
		background: "#F2F4F7 !important",
		color: "#98A2B3 !important",
		textAlign: "left",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		fontWeight: "400 !important",
		//  border: "1px solid #D0D5DD !important",
		borderRadius: "0.8rem !important",
		boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",

		"&.Mui-focused": {
			border: "1px solid #84CAFF !important",
			boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF  !important",
			background: "#FFFFFF !important",
		},
		"& .MuiSelect-outlined": {},
		"& fieldSet": {
			border: "none",
		},

		"& .MuiSelect-icon": {
			width: "2em !important",
			height: "2em !important",
			top: "0.5rem !important",
		},
		"&.Mui-error": {
			border: "1px solid red !important",
		},
		"& .MuiSelect-select": {
			padding: "0.8rem 1.4rem !important",
			// padding: "1.4rem 1.4rem !important",
		},
		"& .MuiPaper-root": {
			height: "30rem !important",
		},
	},
	wrapperli: {
		display: "flex",
		flexDirection: "row",
		width: "100% !important",
		justifyContent: "space-between",
		textTransform: "capitalize",
		// textOverflow: "ellipsis",
		whiteSpace: "break-spaces",
		overflow: "hidden",
		gap: "2.6rem",
	},
	labelTitle: {
		fontFamily: "Inter-Medium",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		letterSpacing: "0.3px",
		color: "#344054",
	},
	labelCss: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: 500,
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#344054",
		marginBottom: "0.5rem",
	},
	wrapperDeleteEdit: {
		display: "flex",
		columnGap: "2rem",
	},
}));
const MenuProps = {
	PaperProps: {
		style: {
			// !!height of ul
			maxHeight: 150,
			// width: 250,
			overflowX: "auto",
			"& .MuiSelected": {
				color: "#F9FAFB !important",
			},
		},
	},
};

const containsText = (text, searchText) => text?.toLowerCase()?.indexOf(searchText?.toLowerCase()) > -1;
//style.color is placeholder's color only
export default function DropDown({
	list,
	selectedValue,
	addIconDisplay = false,
	onChangeSelect,
	label = "",
	helperText = "",
	style,
	placeHolder = "Select",
	disable = false,
	mandatory = false,
	onChangeEdit,
	onChangeDelete,
	isSearch,
	inputStyle = {},
	borderShadow = "",
}) {
	const classes = useStyles();
	const [searchText, setSearchText] = useState("");

	const [displayOptions, setDisplayOptions] = useState([]);

	// console.log("value in drop======>", value)
	useEffect(() => {
		setDisplayOptions(list);
	}, [list]);

	useEffect(() => {
		setDisplayOptions(list.filter((option) => containsText(option?.label, searchText)));
	}, [searchText]);

	return (
		<div style={{ minWidth: `${style?.minWidth ? style.minWidth : ""}` }}>
			<div className={classes.labelCss}>
				{label}
				{mandatory && <span style={{ color: "red" }}> *</span>}
			</div>
			<FormControl fullWidth sx={{ m: 1, mt: 3 }} className={classes.form} disabled={disable} error={helperText === "" ? false : true}>
				{selectedValue === "" ? (
					<InputLabel
						id="demo-simple-select-label"
						className={classes.label}
						sx={[
							{
								color: style?.color ? style?.color + "!important" : "",
								background: style?.background ? style?.background + "!important" : "",
							},
						]}
					>
						{placeHolder}
					</InputLabel>
				) : (
					""
				)}
				<Select
					defaultValue=""
					labelId="demo-simple-select-label"
					id="demo-simple-select"
					MenuProps={MenuProps}
					className={classes.select}
					IconComponent={addIconDisplay ? AddIcon : KeyboardArrowDownIcon}
					sx={[
						{
							color: style?.selectedColor ? `${style?.selectedColor} !important` : "#D0D5DD",
							background: style?.background + "!important",
							"& .MuiList-root-MuiMenu-list": {
								maxWidth: "25% !important",
								height: "24rem !important",
								"& .MuiButtonBase-root-MuiMenuItem-root.Mui-selected": {
									backgroundColor: "rgba(25, 118, 210, 0.08) !important",
								},
							},
							"& #checkedIcon": {
								display: "none",
							},
							"& #isEdit": {
								display: "none",
							},
							"& #isDelete": {
								display: "none",
							},
							"& .makeStyles-wrapperli-11 > div:nth-of-type(1)": {
								overflow: "hidden",
								textOverflow: "ellipsis",
								whiteSpace: "nowrap",
								width: "80%",
							},
							"& .MuiInputBase-root": {
								...inputStyle,
								width: "500px",
							},
							// maxWidth:'25% !important',
						},
					]}
					value={selectedValue}
					onChange={(e) => {
						onChangeSelect(e.target.value);
					}}
				>
					{isSearch && (
						<ListSubheader sx={{ marginTop: "10px" }}>
							<TextField
								size="small"
								// Autofocus on textfield
								autoFocus
								sx={{
									"& .MuiInputBase-root-MuiOutlinedInput-root": {
										fontSize: "2rem",
									},
								}}
								placeholder={placeHolder || "Search by Person"}
								fullWidth
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<SearchIcon sx={{ transform: "scale(1.5)" }} />
										</InputAdornment>
									),
								}}
								inputProps={{ style: { fontSize: "2rem" } }}
								onChange={(e) => setSearchText(e.target.value)}
								onKeyDown={(e) => {
									// if (e.key !== "Escape") {
									// Prevents autoselecting item while typing (default Select behaviour)
									e.stopPropagation();
									// }
								}}
							/>
						</ListSubheader>
					)}
					{(isSearch ? displayOptions : list)?.map((element, index) => (
						<MenuItem
							className={classes.dropDown}
							sx={[
								{
									fontFamily: "Inter-Medium",
									fontSize: "1.4rem !important",
									background: "#FFFfF !important",
									color: "#101828 !important",
									borderBottom: "1px solid #F2F4F7 !important",
									// "& .ul":{

                  "& ul.MuiMenu-list": {
                    height: "20rem !important",
                  },
                  // },
                  //  paddingBottom:"0rem",
                  "& ul .MuiList-root-MuiMenu-list": {
                    paddingBottom: "0rem !important",
                    // backgroundColor: "#FFFFFF",
                  },
                },
              ]}
              //  input={<OutlinedInput label="Tag" />}
              key={index}
            //   value={element?.value ? element?.value : element}

			value={element?.hasOwnProperty("value") ? element.value : element}

              selected={element?.selected}
            >
              <div className={classes.wrapperli}>
                {element?.label ? (
                  <div>{element?.label}</div>
                ) : (
                  <div>{element}</div>
                )}

                <div className={classes.wrapperDeleteEdit}>
                  {element?.isSelected && (
                    <CheckIcon
                      id="checkedIcon"
                      sx={{ fontSize: "2rem", color: "rgb(21, 112, 239)" }}
                    />
                  )}

                  {element?.isDelete && index > 0 && (
                    <Tooltip title="Delete" disableInteractive>
                      <DeleteIcon
                        id="isDelete"
                        style={{
                          width: "2.5rem",
                          height: "2.5rem",
                          color: "#B42318",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          onChangeDelete(
                            element?.value ? element?.value : element
                          );
                        }}
                      />
                    </Tooltip>
                  )}
                  {element?.isEdit && (
                    <Tooltip title="Edit" disableInteractive>
                      <EditIcon
                        id="isEdit"
                        style={{
                          fontSize: "2rem",
                          cursor: "pointer",
                          color: "rgb(21, 112, 239)",
                        }}
                        onClick={() => {
                          onChangeEdit(element?.value ? element?.value : element);
                        }}
                      />
                    </Tooltip>
                  )}
                </div>
              </div>
            </MenuItem>
          ))}
        </Select>
        {helperText !== "" && (
          <FormHelperText className={classes.helperText}>
            {helperText}
          </FormHelperText>
        )}
      </FormControl>
    </div>
  );
}
